import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.user_1 = user;
        this.authenticated_1 = authenticated;
        this.loading_1 = loading;
        this.error_1 = error;
        this.loginWithRedirect_1 = loginWithRedirect;
        this.getIdTokenClaims_1 = getIdTokenClaims;
        this.logout_1 = logout;
        this.getAccessTokenSilently_1 = getAccessTokenSilently;
      }
      component2_7eebsb_k$() {
        return this.authenticated_1;
      }
      component3_7eebsa_k$() {
        return this.loading_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.user_1) + ', authenticated=' + this.authenticated_1 + ', loading=' + this.loading_1 + ', error=' + toString(this.error_1) + ', loginWithRedirect=' + toString_0(this.loginWithRedirect_1) + ', getIdTokenClaims=' + toString_0(this.getIdTokenClaims_1) + ', logout=' + toString_0(this.logout_1) + ', getAccessTokenSilently=' + toString_0(this.getAccessTokenSilently_1) + ')';
      }
      hashCode() {
        var result = this.user_1 == null ? 0 : hashCode(this.user_1);
        result = imul(result, 31) + getBooleanHashCode(this.authenticated_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.loading_1) | 0;
        result = imul(result, 31) + (this.error_1 == null ? 0 : hashCode(this.error_1)) | 0;
        result = imul(result, 31) + hashCode(this.loginWithRedirect_1) | 0;
        result = imul(result, 31) + hashCode(this.getIdTokenClaims_1) | 0;
        result = imul(result, 31) + hashCode(this.logout_1) | 0;
        result = imul(result, 31) + hashCode(this.getAccessTokenSilently_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.user_1, other.user_1))
          return false;
        if (!(this.authenticated_1 === other.authenticated_1))
          return false;
        if (!(this.loading_1 === other.loading_1))
          return false;
        if (!equals(this.error_1, other.error_1))
          return false;
        if (!equals(this.loginWithRedirect_1, other.loginWithRedirect_1))
          return false;
        if (!equals(this.getIdTokenClaims_1, other.getIdTokenClaims_1))
          return false;
        if (!equals(this.logout_1, other.logout_1))
          return false;
        if (!equals(this.getAccessTokenSilently_1, other.getAccessTokenSilently_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
